var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"label-20 averta-black mb-5"},[_vm._v("Tambah Cabang")]),_c('div',[_c('ClientInfo',{staticClass:"mb-5",attrs:{"typeSection":"information","name":_vm.dataClient.name,"companyName":_vm.dataClient.company_name,"logo":_vm.dataClient.logo}}),_c('BranchInfo',{attrs:{"currentTab":"branch"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }